<template>
    <div>
      <div :class="isAdmin ? 'd-flex align-center mb-10 mt-8' : ''">
        <h6 v-if="elements.length > 0" class="mb-3 mt-1">PRAKTISKA MOMENT</h6>
        <v-spacer></v-spacer>
        <v-btn v-if="elements.length && isAdmin" @click="approveAllElements()" :disabled="isAllElementsApproved">
          <v-icon>
            $sl-like
          </v-icon>
          <span class="d-xs-none">{{ $vuetify.breakpoint.xs ? 'Godk.' : 'Godkänn' }} alla moment</span>
        </v-btn>
      </div>
      <v-expansion-panels v-if="elements.length" class="progressbar mt-4">
        <v-expansion-panel v-for="(element, i) in elements" :key="i" hide-actions class="mb-4">
          <v-row align="center" no-gutters class="mt-4 mr-4" v-if="elements.length && isAdmin">
            <v-spacer></v-spacer>
            <v-btn outlined @click="deleteElement(element.id)" :disabled="isElementsApproved(element)"> <v-icon>$sl-delete</v-icon>Radera</v-btn>
            <v-btn class="ml-4" @click="approveElement(element.id, element, element.bookSubElements)" :disabled="isElementsApproved(element)">
              <v-icon>$sl-like</v-icon>
              <span class="d-xs-none">{{ $vuetify.breakpoint.xs ? 'Godk.' : 'Godkänn' }}</span>
            </v-btn>
          </v-row>
          <v-expansion-panel-header v-bind:class="{ active: Number(element.isApproved) }">
            <v-row align="center" class="spacer" no-gutters>
              <v-col class="subtitle-1 text-uppercase bold d-flex align-center" cols="12">  
                {{ element.name }}
                <v-icon class="ml-1" v-if="element.isApproved ||
                  filter(element.bookSubElements, ['isApproved', true]).length ===
                      element.bookSubElements.length && element.bookSubElements.length">
                      $sl-ebook-completed
                </v-icon>                
            </v-col>
              <v-col cols="12">
                <progressLinear
                  class="mt-n1 mb-n1"
                  :value="
                    getPercentage(
                      filter(element.bookSubElements, ['isApproved', true]).length,
                      element.bookSubElements.length)"></progressLinear>
              </v-col>
            </v-row>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-container class="pt-0">
              <v-row v-if="!element.isApproved" class="flex-column">
                {{ `För att ${ apprenticeName } ska bli godkänd i detta moment krävs godkänt i delmomenten:` }}
                <br />
                <br />
                <ul class="pl-0">
                  <li 
                    v-for="(item, index) in uniqBy(filter(element.bookSubElements, ['isApproved', false]), 'name')" 
                    :key="index"
                    :style="{ listStyle: 'none' }"
                  >
                    <i>- {{item.name}}</i>
                  </li>
                </ul>
              </v-row>

              <v-divider class="fullwidth mt-5 mb-1"></v-divider>
              <v-row class="no-gutters d-flex justify-end">
                <v-col cols="12"></v-col>
                <v-col cols="8" class="smallTitle">
                  <div>Godk. Adm</div>
                  <div>Klar</div>
                  <template>
                    <div>{{apprenticeName | filterGenitiveName }} nivå</div>
                    <div>Nivå krav</div>
                    <div v-if="isAdmin">Radera / Godkänn</div>
                  </template>
                  <div class="text-center">Rapport utförd av lärling</div>  
                </v-col>
              </v-row>

              <div v-for="(item, key) in element.bookSubElements" :key="key">
                <template v-if="!item.isApproved">
                  <v-row  v-bind:class="[item.isApproved ? active : '', elementRow, noGutters]">
                    <v-col cols="20" class="d-flex align-items-center">
                      <div class="itemName">{{item.name}}</div>
                    </v-col>

                    <v-col class="smallTitle justify-end align-center" cols="8">
                      <div>
                        <v-icon v-if="item.isApproved">$sl-ebook-completed</v-icon>
                      </div>
                      <div>
                        <v-icon v-if="item.isApproved">$sl-ebook-completed</v-icon>
                      </div>
                      <div>
                        <v-icon v-if="item.maxInstructorSkillEstimatedLevel ==1">mdi-minus</v-icon>
                        <v-icon
                          v-else-if="item.maxInstructorSkillEstimatedLevel ==2"
                        >mdi-drag-horizontal-variant</v-icon>
                        <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==3">mdi-menu</v-icon>
                        <v-icon
                          v-else-if="item.maxInstructorSkillEstimatedLevel ==4"
                        >mdi-reorder-horizontal</v-icon>
                        <v-icon v-else></v-icon>
                      </div>
                      <div>
                        <v-icon v-if="item.requiredLevel==1">mdi-minus</v-icon>
                        <v-icon v-else-if="item.requiredLevel==2">mdi-drag-horizontal-variant</v-icon>
                        <v-icon v-else-if="item.requiredLevel==3">mdi-menu</v-icon>
                        <v-icon v-else-if="item.requiredLevel==4">mdi-reorder-horizontal</v-icon>
                        <v-icon v-else></v-icon>
                      </div>
                      <div v-if="isAdmin" class="d-flex align-center">
                        <v-icon class="mr-6" @click.stop="deleteSubElement(element.id, item.id)" :disabled="item.isApproved">$sl-delete</v-icon>
                        <v-icon @click.stop="approveSubElement(element.id, item)" :disabled="item.isApproved">$sl-like</v-icon>
                      </div>
                      <div class="d-flex align-center">
                        <v-icon v-if="isRapportCreatedByApprentice(item)">$sl-check</v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-row class="align-center" v-bind:class="[item.isApproved ? active : '', elementRow, noGutters]">
                    <v-col cols="20" class="d-flex align-center">
                      <div class="itemName">{{item.name}}</div>
                    </v-col>

                    <v-col cols="8" class="smallTitle d-flex justify-end align-center">
                      <div>
                        <v-icon v-if="item.isApproved">$sl-ebook-completed</v-icon>
                      </div>
                      <div>
                        <v-icon v-if="item.isApproved">$sl-ebook-completed</v-icon>
                      </div>
                      <div>
                        <v-icon v-if="item.maxInstructorSkillEstimatedLevel ==1">mdi-minus</v-icon>
                        <v-icon
                          v-else-if="item.maxInstructorSkillEstimatedLevel ==2"
                        >mdi-drag-horizontal-variant</v-icon>
                        <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==3">mdi-menu</v-icon>
                        <v-icon
                          v-else-if="item.maxInstructorSkillEstimatedLevel ==4"
                        >mdi-reorder-horizontal</v-icon>
                        <v-icon v-else>$sl-ebook-lvl2</v-icon>
                      </div>
                      <div>
                        <v-icon v-if="item.requiredLevel==1">mdi-minus</v-icon>
                        <v-icon v-else-if="item.requiredLevel==2">mdi-drag-horizontal-variant</v-icon>
                        <v-icon v-else-if="item.requiredLevel==3">mdi-menu</v-icon>
                        <v-icon v-else-if="item.requiredLevel==4">mdi-reorder-horizontal</v-icon>
                        <v-icon v-else></v-icon>
                      </div>
                      <div v-if="isAdmin" class="d-flex align-center">
                        <v-icon class="mr-6" @click.stop="deleteSubElement(element.id, item.subElementId)" :disabled="item.isApproved">$sl-delete</v-icon>
                        <v-icon @click.stop="approveSubElement(element.id, item)" :disabled="item.isApproved">$sl-like</v-icon>
                      </div>
                      <div class="d-flex align-center">
                        <v-icon v-if="isRapportCreatedByApprentice(item)">$sl-check</v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </div>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import progressLinear from '@/components/common/ProgressLinear'
import filter from 'lodash/filter'
import countBy from 'lodash/countBy'
import API from '@/services/api'
import findIndex from 'lodash/findIndex'
import get from 'lodash/get'
import {Utilities} from '@/components/mixins'
import uniqBy from 'lodash/uniqBy'

// @group Common
// Styled ElementExpansionPanel component
export default {
  name: 'ElementExpansionPanel',

  props: {
    //has elements
    elements: Array,
    //has apprentice name
    apprenticeName: {
      // `String`
      type: String,
      // The default value is: `empty string`
      default: ''
    },

    book: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [Utilities],

  components: {progressLinear},

  data: () => ({
    active: 'active',
    elementRow: 'element-row',
    noGutters: 'no-gutters',
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUserRole']),
    ...mapGetters("person", ["selectedPerson"]),
    isAdmin() {
      return this.currentUserRole === 'admin';
    },
    isElementsApproved() {
      return (element) => element.isApproved 
    },
    isAllElementsApproved() {
      return !!this.isElementsApproved && !!this.elements.every(e => e.bookSubElements.every(sE => sE.isApproved))
    },
    approvedElementCount() {
      return this.elements.filter(o => o.isApproved).length
      return (element, subElements) => element.isApproved || 
      filter(subElements, ['isApproved', true]).length === subElements.length
    },
    
    isRapportCreatedByApprentice() {
      return item => !!get(item, 'reportDetails', [])?.some(o => {
        return o?.subElementId === item?.id && o?.apprenticeshipSkillEstimatedLevel > 0 && o?.report?.status !== 'draft'
      })
    }
  },

  filters: {    
    filterGenitiveName(name) {
      if (name && name.length > 0) {
        if (name.slice(-1) == 's') return name
      }
      return name + 's'
    }
  },
  methods: {

    uniqBy,

    filter: filter,

    async approveAllElements() {

      const response = await this.$dialog.confirm({
        title: 'Godkänn alla moment?',
        text: 'Samtliga tillhörande delmoment kommer också att bli godkända.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Godkänn', key: true, icon: '$sl-like', outlined: true}
        ]
      })

      if(response !== true) return

      for (const element of this.elements) {
        element.isApproved = true
        element.numSubElementsFinished = element.bookSubElements.length
        element.numSubElementsRequiredFinished = element.bookSubElements.length
        
        for (const subElement of element.bookSubElements) {
          subElement.isApproved = true
          subElement.maxInstructorSkillEstimatedLevel = subElement.requiredLevel
        }
      }

      API.approveAllElements({ data: { elements: this.elements } }).then(() => {
        this.$events.fire('showInfo', 'Samtliga moment är godkända.')
        this.book.bookElementsApprovedCount = this.approvedElementCount
      })
    },

    async approveElement(elementId, element, subElements) {
      const response = await this.$dialog.confirm({
        title: 'Godkänn moment?',
        text: 'Samtliga tillhörande delmoment kommer också att bli godkända.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Godkänn', key: true, icon: '$sl-like', outlined: true}
        ]
      })

      if(response !== true) return

      element.isApproved = true
      
      const data = {
        isApproved: true,
        numSubElementsFinished: element.bookSubElements.length,
        numSubElementsRequiredFinished: element.bookSubElements.length
      }

      API.approveBookElement(elementId, { data })
        .then(() => {
          for (const subElement of subElements) {
            subElement.maxInstructorSkillEstimatedLevel = subElement.requiredLevel,
            subElement.isApproved = true
          }
          
          this.$events.fire('showInfo', 'Moment godkänd.')
        })
        .catch(err => console.log(`Error ==> ${err}`))
    },

    async approveSubElement(elementId, subElement) {
      const response = await this.$dialog.confirm({
        title: 'Godkänn delmoment?',
        text: 'Vill du godkänna delmomentet?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Godkänn', key: true, icon: '$sl-like', outlined: true}
        ]
      })

      if(response !== true) return

      subElement.isApproved = true
      const element = this.elements.find(e => e.id === elementId)
      
      if(filter(element.bookSubElements, ['isApproved', true]).length === element.bookSubElements.length) {
        element.isApproved = true
      }

      subElement.maxInstructorSkillEstimatedLevel = subElement.requiredLevel

      const subElements = [{
        id: subElement.id,
        requiredLevel: subElement.requiredLevel
      }]

      API.approveBookSubElement(elementId, { data: { subElements } }).then((response) => {
        this.$events.fire('showInfo', 'Delmoment godkänd.')
        this.book.bookElementsApprovedCount = this.approvedElementCount
      })
    },

    async deleteElement(elementId) {
      const response = await this.$dialog.confirm({
        title: 'Radera moment?',
        text: 'Samtliga tillhörande delmoment kommer också att raderas. Radering av moment går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if(response !== true) return

      API.deleteBookElement(elementId).then((response) => {
        this.filterDeletedElements(elementId)
        this.$events.fire('showInfo', 'Moment raderad.')
      })
    },

    async deleteSubElement(elementId, id) {
      const response = await this.$dialog.confirm({
        title: 'Radera delmoment?',
        text: 'Vill du radera delmoment? Radering av delmoment går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if(response !== true) return

      API.deleteBookSubElement(elementId, id).then((response) => {
        this.filterDeletedSubElements(elementId, id)

        const element = this.elements.find(e => e.id === elementId)
      
        if(element.bookSubElements.length && filter(element.bookSubElements, ['isApproved', true]).length === element.bookSubElements.length) {
          element.isApproved = true
          API.approveBookElement(elementId, { data: { isApproved: true } }).then(() => {
            this.book.bookElementsApprovedCount = this.approvedElementCount
          })
        }

        this.$events.fire('showInfo', 'Delmoment raderad.')
      })
    },

    filterDeletedElements(elementId) {
      const elIdx = findIndex(this.elements, e => {
        return e.id === elementId
      })

      if (elIdx === -1) return
      this.elements.splice(elIdx, 1)
    },

    filterDeletedSubElements(elementId, id) {
      const elIdx = findIndex(this.elements, e => {
        return e.id == elementId
      })

      const itIdx = findIndex(this.elements[elIdx].bookSubElements, se => {
        return se.id === id
      })

      if (itIdx > -1) {
        const deleted = this.elements[elIdx].bookSubElements.splice(itIdx, 1)

        // Reorder the ones left
        const items = filter(this.elements[elIdx].bookSubElements, se => {
          return se.order > deleted[0].order
        })

        items.forEach(i => {
          API.updateSubElement(elementId, i.id, {data: {order: i.order - 1}})
            .then(res => {
              i.order = i.order - 1
            })
            .catch(err => {
              console.log(err)
          })
        })
      }
    },
    clickInfo(item, parentName){
      item.parentName=parentName
    },
    isApproved(val) {      
      if (val.maxInstructorSkillEstimatedLevel && val.requiredLevel) {
        if (val.maxInstructorSkillEstimatedLevel >= val.requiredLevel) return true
      }
      return false
    },
    countSubElements(element) {
      const h = countBy(filter(element.bookSubElements, ['isApproved', false]), 'requiredLevel')
      return h
    },
  }
}
</script>
